import * as zExt from "@redotech/rpc/ext";
import * as z from "zod/v4";

export const redoProducts = [
  "Returns",
  "OMS",
  "Marketing",
  "Shopper AI",
  "Checkout",
  "General",
] as const;
export type RedoProduct = (typeof redoProducts)[number];

const featureRequestSchema = z.object({
  _id: zExt.objectId(),
  source: z.enum(["slack", "linear", "hubspot"]),
  sourceMessageId: z.string(),
  sourceUrl: z.string().optional(),
  teamId: zExt.objectId(),
  teamName: z.string().optional(),
  title: z.string(),
  description: z.string(),
  rawContent: z.string(),
  confidence: z.number(),
  product: z.enum(redoProducts).optional(),
  clusterId: zExt.objectId().nullable(),
  status: z.enum(["pending", "clustered"]),
  createdAt: z.date(),
  updatedAt: z.date(),
});

export const getAllFeatureRequests = {
  name: "getAllFeatureRequests" as const,
  input: z.object({
    source: z.enum(["slack", "linear", "hubspot"]).optional(),
    status: z.enum(["pending", "clustered"]).optional(),
    product: z.enum(redoProducts).optional(),
    teamId: zExt.objectId().optional(),
    search: z.string().optional(),
    page: z.number().int().positive().optional(),
    pageSize: z.number().int().positive().optional(),
  }),
  output: z.object({
    requests: z.array(featureRequestSchema),
    totalCount: z.number(),
  }),
};
